import { useAuth } from '@/auth/AuthContext';
import { Spin } from 'antd';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * SSO 落地页：从产品站（@suite/web）或运维台用 URL fragment 带 token 跳转过来，
 * 免二次登录进入财务系统。
 *
 * 跨子域名 localStorage 不共享，故产品站不能直接把登录态带过来——用与「短剧工坊」
 * fragment 不会进入 nginx/access log 或 Referer；query 仅作为旧版本兼容回退。
 * 本页把 token 落进本标签页的 sessionStorage，再进 /。
 * 无 token 则回落到登录页。StaffGuard 仍会在进入后校验员工身份，无授权照样 403。
 */
export default function SsoPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = fragment.get('token') ?? params.get('token');
    if (token) {
      login(token);
      navigate('/', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [params, login, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '160px 0' }}>
      <Spin tip="正在进入财务系统…" size="large">
        <div style={{ width: 1, height: 1 }} />
      </Spin>
    </div>
  );
}
